import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import Home from '@/views/home.vue'
import Main from '@/views/main.vue'
import Download from '@/views/download.vue'
import NotFound from '@/views/not-found.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      hideForAuth: true
    }
  },
  {
    path: '/signin',
    name: 'Signin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/signin.vue')
  },
  {
    path: '/app',
    name: 'Main',
    component: Main,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/download',
    name: 'Download',
    component: Download,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  }
]

const router = new VueRouter({
  // base: '/smart-solar-web/', // Used when testing with xampp
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.signedIn) {
    next({
      path: '/signin',
      query: { redirect: to.fullPath }
    })
  } else if (to.matched.some(record => record.meta.hideForAuth) && store.getters.signedIn) {
    next({
      path: '/app',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router
